import { isEmpty } from 'lodash-es';
import { isFertigationMetric, isHydricStress } from '../../enums/MetricIds';
function isIrrigationDevice(device) {
    return (!isEmpty(device.availableMeasures) &&
        device.availableMeasures.some((m) => isHydricStress(m) || isFertigationMetric(m)));
}
export default isIrrigationDevice;
